export default __webpack_public_path__ + "static/media/flag-isle-of-man.2d06b317.svg";